import { render, staticRenderFns } from "./cash-receipts.vue?vue&type=template&id=8fb9c45a&"
import script from "./cash-receipts.vue?vue&type=script&lang=js&"
export * from "./cash-receipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports